/**
 * Nado failure code → the copy the user sees. Core classifies; each platform
 * owns its map, and an exhaustive `Record` fails the build on a new code.
 *
 * Thunks rather than a key lookup: `t(KEYS[code])` passes a non-literal to `t`,
 * which `.ast-grep/rules/i18n-t-string-literal.yml` rejects.
 */

import {
  type NadoWithdrawalFailure,
  toNadoWithdrawalFailure,
} from '@funkit/connect-core/clients/nado'

import { i18n } from '../../src/locales/i18n'

const MESSAGE_FOR: Record<NadoWithdrawalFailure, () => string> = {
  generic: () => i18n.t('withdrawCrypto.errorGeneric'),
  network: () => i18n.t('withdrawNado.errorNetwork'),
  rateLimited: () => i18n.t('withdrawNado.errorRateLimited'),
  // Borrowing is off on mobile, so this only ever means the balance moved.
  exceedsBorrowLimit: () => i18n.t('withdrawNado.errorBalanceChanged'),
  invalidNonce: () => i18n.t('withdrawNado.errorInvalidNonce'),
  noPriorDeposit: () => i18n.t('withdrawNado.errorNoPriorDeposit'),
  withdrawRisk: () => i18n.t('withdrawNado.errorWithdrawRisk'),
  unconfirmed: () => i18n.t('withdrawNado.errorUnconfirmed'),
}

export function toNadoWithdrawalErrorMessage(error: unknown): string {
  return MESSAGE_FOR[toNadoWithdrawalFailure(error)]()
}
